import { render } from "./CreateProductPanel.vue?vue&type=template&id=254076b1&scoped=true"
import script from "./CreateProductPanel.vue?vue&type=script&lang=js"
export * from "./CreateProductPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254076b1"]])

export default __exports__